import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faDownload, faCloudUploadAlt, faQuestionCircle, faCog, faCloud, faRoad, faUser, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { NavLink, useHistory, Redirect, withRouter, Link } from 'react-router-dom';
import { clearSession, clearCookie, getPrivileges, isLogin } from '../../functions/Auth';
import MyProfile from '../UserManagement/MyProfile';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const drawerWidth = 240;


//Start Css Code ....
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%'
  },
  toolbar: {
    paddingRight: 24,    
    backgroundColor: '#D7D7D7',
    '@media only screen and (max-width: 3500px)': {
      height: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '60px',
    }, 
  },
  title: {
    flexGrow: 1,
    color: '#333333',    
    marginLeft: '30px',
    fontFamily: 'Avenir_Black',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '24pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '32pt',
    }, 
  },
  signIn: {
    flexGrow: 1,
    color: '#24618E',
    fontSize: '14pt',
    marginLeft: '10px',
    '@media only screen and (max-width: 3500px)': {
      marginTop: '1%'
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '0.7%'
    }, 
  },
  paper: {
    margin: theme.spacing(1),
    paddingBottom: '3px',
  },
  dropMenu: {
    position: 'absolute',    
    zIndex: '999',
    minWidth: '200px',
    minWidth:'200px',
    '@media only screen and (max-width: 3500px)': {
      top: '37px',
    },
    '@media only screen and (min-width: 3501px)': {
      top: '60px',
    },
    '& li': {      
      padding: '5px 0px',
      color: '#24618E',
      listStyle: 'none',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '22pt',
      }, 
    },
    '& .MuiPaper-root': {
      border: '1px solid #24618E',
    },
  },
  droplog: {       
    zIndex: '999',
    position: 'absolute',       
    '@media only screen and (max-width: 3500px)': {
      width: '179px',
      top: '40px',
      right: '4%', 
    },
    '@media only screen and (min-width: 3501px)': {
      width: '260px',
      top: '60px',
      right: '2.2%', 
    }, 
    '& .MuiPaper-root': {
      border: '1px solid #24618E',
    }
  },
  dropProfile: {
    '@media only screen and (max-width: 3500px)': {
      top: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      top: '60px',
    }, 
    zIndex: '999',
    position: 'relative',
    width: '100%',
    float: 'left',
    '& .MuiPaper-root': {
      boxShadow: 'none'
    }
  },
  dropMenuUl: {
    paddingLeft: '10px',
    paddingTop: '5px',
  },
  dropAdminTools: {
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '5px',
    borderRadius: '5px',
    '& h5': {
      margin: '5px 5px 0',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '22pt',
      },       
      fontWeight: 'normal',
    },
    '& ul': {
      margin: '2px 5px 0',
      paddingRight: '15px',
      paddingLeft: '25px',
    },
  },
  menuIuseEffectcon: {
    fontSize: '18px',
    marginRight: '10px',
  },
  toolbarIcon: {
    cursor: 'pointer',
    color: '#333',
    '@media only screen and (max-width: 3500px)': {
      height: '50px', width: '50px',
    },
    '@media only screen and (min-width: 3501px)': {
      height: '70px', width: '70px',
    }, 
  },
  adminMenu: {
    padding: '10px',
  },
  header: {
    position: 'absolute',
    top: '0',
    width: '100%',
    zIndex:2,
    '& .MuiAppBar-colorPrimary': {
      backgroundColor: '#D7D7D7',
      borderBottom: '1px solid #24618E',
      padding: '5px 0',
    },
    '& .MuiToolbar-regular': {  
      '@media only screen and (max-width: 3500px)': {
        minHeight: '40px',
      },
      '@media only screen and (min-width: 3501px)': {
        minHeight: '60px',
      }, 
    },
    '& .MuiAppBar-root': {
      boxShadow: 'none',
    }
  },
  userDrop: {
    cursor: 'pointer',
    margin: '5px',
    color: '#24618E',   
    '@media only screen and (max-width: 3500px)': {
      fontSize: '16px'
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt'
    },
  },
  userIcon: {
    color: '#24618E',    
    marginTop: '2px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '25px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '40px',
    },
  },
  dropImportData: {
    position: 'absolute',
  },
  notificationIcon: {
    color: '#fff',
    fontWeight: 'bold',
    background: '#00A75D',
    height: '23px',
    padding: '2px 5px',
    fontSize: '12pt',
    borderRadius: '50%',
    position: 'relative',
    left: '-5px',
    border: '1px solid #24618E',
  },
  headerIcon:{
    '@media only screen and (max-width: 3500px)': {
      height: '38px',width: '164px',marginLeft: '25px',marginBottom:'-10px'
    },
    '@media only screen and (min-width: 3501px)': {
      height: '55px',width: '235px',marginLeft: '25px',marginBottom:'-15px'
    }, 
  },
}));
//End Css Code ....


//Start UserHeader component code ...
const UserHeader = (props) => {
  let history = useHistory();
  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);
  const [checkedlog, setCheckedLog] = React.useState(false);
  const [checkProfile, setCheckProfile] = React.useState(false);
  const [userCount, setUserCount] = React.useState(0);
  useEffect(
    () => {
      if (getPrivileges().includes(1)) {
        getNewUserCount();
      }
    }, [])

  //This method is use for show new user notification ..... start  
  const getNewUserCount = () => {
    try {
      axios({
        method: 'get',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getUserNotification,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setUserCount(response.data.data.count)
          }
        }).catch(function (error) {
          console.log(error)
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for show new user notification ..... end

  //This method is use for show update new user notification ..... start  
  const updateNewUserCount = () => {
    try {
      axios({
        method: 'post',
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.updateUserNotification,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setUserCount(response.data.data.count);
            history.push('/users_management');
          }
        }).catch(function (error) {
          console.log(error);
          history.push('/users_management');
        })
    } catch (error) {
      console.error(error);
      history.push('/users_management');
    }
  }
  //This method is use for show update new user notification ..... end

  const handleMenu = () => {
    setChecked((prev) => !prev);
  };
  const handleLogout = () => {
    setCheckedLog((prev) => !prev);
  };
  const showMyProfile = () => {
    setCheckProfile((prev) => !prev);
    setCheckedLog(false);
  }
  const userMenu = () => {
    setCheckedLog(false);
  }
  const hideMyProfile = () => {
    setCheckProfile(false);
  }

  //This method is use for signout user ... start
  const signOutUser = () => {
    if (Cookies.get('email')) {
      try {
        axios({
          method: 'post',
          data: { 'email': Cookies.get('email') },
          url: API_URL + API_PATH.signOutAPI,
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              clearCookies();
              history.push("/");
            }
          })
          .catch(function (error) {
            clearCookies();
            history.push("/");
          })
      } catch (error) {
        clearCookies();
        history.push("/");
      }
    } else {
      history.push("/");
    }
  }
  //This method is use for signout user ... end

  const clearCookies = () => {
    clearCookie('email');
    clearCookie('payload');
    clearCookie('idToken');
    clearCookie('organization');
    clearCookie('atexpiry');
    clearCookie('firstName');
    clearCookie('lastName');
    clearCookie('alLogIn');
    clearCookie('stationDetailsMap');
    clearCookie('activeSearchFilter');
    clearCookie('activeSearchStation');
    sessionStorage.removeItem('activeSearchResult');
    clearCookie('activeSearchText');
    clearCookie('polygonExtent');
    clearCookie('externalLayers');
    clearCookie('geolayer');
  }

  const handleClickAway = () => {
    setChecked(false);
  };
  return (
    <React.Fragment>
      <div className={classes.header}>
        <div className={classes.root}>
          <CssBaseline />
          <AppBar position="relative">
            <Toolbar className={classes.toolbar}>
              <ClickAwayListener onClickAway={() => handleClickAway()}>
                {
                  isLogin() ?
                    <MenuIcon onClick={handleMenu} className={classes.toolbarIcon} />
                    :
                    <Redirect to='/' />
                }
              </ClickAwayListener>
              {userCount > 0 ? <span className={classes.notificationIcon}>{userCount}</span> : null}
              <NavLink to={{ pathname: '/UsersDashboard', state: { clicked: true } }} style={{ textDecoration: 'none' }}><img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.headerIcon}/></NavLink>
              <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                {sessionStorage.getItem('displayName')}
              </Typography>

              <div style={{ display: 'inline-flex', paddingRight: '70px', cursor: 'pointer' }} onClick={handleLogout}>
                <FontAwesomeIcon icon={faUserCircle} className={classes.userIcon} />
                <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.signIn}>
                  {
                    isLogin() ?
                      <span className={classes.signoutSpan} >{Cookies.get('firstName') + ' ' + Cookies.get('lastName')}</span>
                      :
                      history.push('/')
                  }
                </Typography></div>
            </Toolbar>
          </AppBar>
        </div>
        {checked ?
          <div className={classes.dropMenu} style={!getPrivileges().includes(1) && !getPrivileges().includes(2) ? { width: '125px' } : null}>

            <Collapse in={checked}>
              <Paper elevation={4} className={classes.paper}>
                <ul className={classes.dropMenuUl}>
                  <li><NavLink to={{ pathname: '/UsersDashboard', state: { clicked: true } }}  style={{ textDecoration: 'none', color: '#24618E' }} title="Home"><FontAwesomeIcon icon={faHome} className={classes.menuIcon} /> Home</NavLink></li>                 
                  {
                    getPrivileges().length === 1 && getPrivileges().includes(3) ?
                    null :
                    getPrivileges().length !== 0 ?
                    <li title="Import Data"><NavLink to={`/UsersDashboard?import=` + 1} style={{ textDecoration: 'none', color: '#24618E' }} title="Import Data"><FontAwesomeIcon icon={faCloudUploadAlt} className={classes.menuIcon} /> Import Data</NavLink></li> 
                    : null}
                  <li title="Help"><NavLink to="/help" style={{ textDecoration: 'none', color: '#24618E' }} title="Help"><FontAwesomeIcon icon={faQuestionCircle} className={classes.menuIcon} /> Help</NavLink></li>
                </ul>

                {
                  getPrivileges().includes(1) ?
                    <div className={classes.dropAdminTools}>
                      <h5><FontAwesomeIcon icon={faCog} className={classes.menuIcon} /> Admin Tools</h5>
                      <ul className={classes.dropMenuAdmin}>
                        <li title="Data Management"><NavLink to="/data_management" style={{ textDecoration: 'none', color: '#24618E' }} title="Data Management"><FontAwesomeIcon icon={faCloud} className={classes.menuIcon} /> Data Management</NavLink></li>                        
                        <li title="User Management"><NavLink to="#" onClick={() => updateNewUserCount()} style={{ textDecoration: 'none', color: '#24618E' }} title="User Management"><FontAwesomeIcon icon={faUser} className={classes.menuIcon} title="User Management" /> User Management <span style={{ color: 'rgba(0, 167, 93, 1)', fontWeight: 'bold' }}>{userCount > 0 ? userCount : null}</span></NavLink></li>
                      </ul>
                    </div>
                    : null
                }

              </Paper>
            </Collapse>
          </div> : null}
        {checkedlog ?
          <div className={classes.droplog}>
            <Collapse in={checkedlog}>
              <Paper elevation={4} className={classes.paper}>
                <div className={classes.adminMenu}>
                  <ClickAwayListener onClickAway={() => userMenu()}>
                    <p className={classes.userDrop} onClick={showMyProfile}>My Profile</p>
                  </ClickAwayListener>
                  <p className={classes.userDrop} onClick={() => { signOutUser() }}>Sign Out</p>
                </div>
              </Paper>
            </Collapse>
          </div> : null}
      </div>
      {checkProfile ?
        <div className={classes.dropProfile}>
          <Collapse in={checkProfile}>
            <Paper elevation={4} className={classes.paper}>
              <MyProfile checkValue={hideMyProfile} />
            </Paper>
          </Collapse>
        </div> : null}

    </React.Fragment>
  );
}

export default withRouter(UserHeader) 
//End UserHeader component code ...